import { path } from "../utils";
import { TradeVolumeIndex as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = { ...defaultOptions };

  function normaliseThreshold(value) {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return 0;
    }
    return Math.max(0, numericValue);
  }

  function calculator(data = []) {
    const { sourcePath, volumePath, minTickValue } = options;

    const getPrice = path(sourcePath);
    const getVolumeRaw = path(volumePath);

    // Helper to extract volume value (handles nested volume.volume structure)
    const getVolume = (d) => {
      const vol = getVolumeRaw(d);
      // If volume is an object with nested volume property (like {direction: "up", volume: 9795})
      if (vol && typeof vol === "object" && "volume" in vol) {
        return vol.volume;
      }
      // Otherwise return as-is (for tickCount, financialVolume, etc.)
      return vol;
    };

    const threshold = normaliseThreshold(minTickValue);

    const results = new Array(data.length).fill(undefined);
    let accumulated = 0;

    for (let index = 0; index < data.length; index += 1) {
      const datum = data[index];
      const previousDatum = index > 0 ? data[index - 1] : undefined;

      if (!previousDatum) {
        results[index] = accumulated;
        continue;
      }

      const currentPrice = getPrice(datum);
      const previousPrice = getPrice(previousDatum);

      if (currentPrice == null || previousPrice == null) {
        results[index] = accumulated;
        continue;
      }

      let direction = 0;
      const priceChange = currentPrice - previousPrice;

      if (priceChange > threshold) {
        direction = 1;
      } else if (priceChange < -threshold) {
        direction = -1;
      }
      // else direction = 0 (no significant price change)

      const volumeCandidate = Number(getVolume(datum));
      const volumeValue = Number.isFinite(volumeCandidate)
        ? volumeCandidate
        : 0;

      accumulated += volumeValue * direction;
      results[index] = accumulated;
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return { ...options };
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
